import React from 'react';

class Services extends React.Component {
    render() {
        return (
            <div id="services" className="section-padding bg-gray">
                <div className="container">
                    <div className="section-header text-center">
                        <h2 className="section-title wow fadeInDown" data-wow-delay="0.3s">Our Services</h2>
                        <p>A desire to help and empower others between community contributors in technology <br /> began to grow in 2020.</p>
                    </div>
                    <div className="row equal">
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="0.3s">
                                <div className="icon">
                                    <i className="lni-display"></i>
                                </div>
                                <div className="services-content">
                                    <h3>Web Development</h3>
                                    <p>We build code, custom websites and web applications, and back-end solutions to engage and convert your audience with our innovative, effective solutions.</p>
                                </div>
                            </div>
                        </div>
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="0.6s">
                                <div className="icon">
                                    <i className="lni-mobile"></i>
                                </div>
                                <div className="services-content">
                                    <h3>Mobile Development</h3>
                                    <p>Delight your users with expressive and feature-rich native IOS / Android, cross-platform Apps leveraging our extensive experience of working with all major technologies.</p>
                                </div>
                            </div>
                        </div>
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="0.9s">
                                <div className="icon">
                                    <i className="lni-cog"></i>
                                </div>
                                <div className="services-content">
                                    <h3>CMS Development</h3>
                                    <p>WordPress is one of the most popular content management systems in the market, which helps you create any kind of responsive website using drag and drop options.</p>
                                </div>
                            </div>
                        </div>
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="1.2s">
                                <div className="icon">
                                    <i className="lni-cloud"></i>
                                </div>
                                <div className="services-content">
                                    <h3>Web Hosting Service</h3>
                                    <p>You need powerful web hosting. A variety of premium features optimized for the best performance will make your websites and applications really fast.</p>
                                </div>
                            </div>
                        </div>
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="1.5s">
                                <div className="icon">
                                    <i className="lni-users"></i>
                                </div>
                                <div className="services-content">
                                    <h3>Dedicated Teams</h3>
                                    <p>No matter how big or small your development challenge is, we offer you top tech talent skilled in the latest software development and programming languages.</p>
                                </div>
                            </div>
                        </div>
                        {/* Services item  */}
                        <div className="col-md-6 col-lg-4 col-xs-12">
                            <div className="services-item wow fadeInRight" data-wow-delay="1.8s">
                                <div className="icon">
                                    <i className="lni-grid"></i>
                                </div>
                                <div className="services-content">
                                    <h3>ERP Solutions</h3>
                                    <p>We help improve business operations, communication, and collaboration including, sales, order processing, finance, human resources,  production, inventory, procurement, and more.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/sections/Services.js